import { render, staticRenderFns } from "./MonthlyAutoInvest.vue?vue&type=template&id=6434215a&"
import script from "./MonthlyAutoInvest.vue?vue&type=script&lang=js&"
export * from "./MonthlyAutoInvest.vue?vue&type=script&lang=js&"
import style0 from "./MonthlyAutoInvest.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports